<div class="position-absolute right d-none d-sm-block"><b>Version</b> {{ appVersion }}</div>
<div class="d-flex justify-content-center">
    <strong>
        <span>Copyright &copy; {{ currentYear }}</span>
        <a>
            Masters</a
        >
        <span>.</span>
    </strong>
    <span> Todos los derechos reservados.</span>
</div>
